import cn from 'classnames';
import * as React from 'react';
import { IconCross } from '../../basics/icons';

interface Props {
  prefix?: React.ReactNode;
  handleClose?: React.MouseEventHandler;
  title: React.ReactNode;
  body: React.ReactNode;
  isVisible: boolean;
}

export const Toast = ({ prefix, handleClose, title, body, isVisible }: Props): JSX.Element => {
  return (
    <div
      className={cn(
        'absolute -left-[15px] -right-[15px] bottom-[calc(100%+10px)] overflow-hidden sm:left-0 sm:right-0 md:bottom-[calc(100%+20px)] print:hidden',
        isVisible ? 'visible max-h-[1000px]' : 'invisible max-h-0'
      )}
    >
      <div
        className={cn(
          'flex items-center justify-between bg-blue-400 py-2.5 text-primary transition-all duration-500 ease-[cubic-bezier(0,0.69,0.46,1)] sm:py-[15px]',
          isVisible ? 'translate-y-0' : 'translate-y-[110%]'
        )}
      >
        {prefix && (
          <div className="pl-2.5 leading-none sm:pl-[15px] [&_svg]:h-10 [&_svg]:w-10 sm:[&_svg]:h-[65px] sm:[&_svg]:w-[65px]">
            {prefix}
          </div>
        )}
        <div
          className={cn(
            'grow pl-2.5 max-sm:leading-[1.3] sm:pl-[15px] [&_ul]:mb-0 [&_ul]:mt-[5px] [&_ul]:pl-[15px]',
            handleClose ? 'pr-[30px]' : 'pr-2.5 sm:pr-[15px]'
          )}
        >
          <h6>{title}</h6>
          <div className="max-sm:text-sm max-sm:-mt-[.15rem] max-sm:leading-[1.4] mb-1">{body}</div>
        </div>
        {handleClose && (
          <div
            className="trigger absolute right-1 top-2 z-10 cursor-pointer px-2.5 pb-2.5 pt-[5px] leading-none [&_svg]:h-[0.7em] [&_svg]:w-[0.7em]"
            onClick={handleClose}
          >
            <IconCross />
          </div>
        )}
      </div>
    </div>
  );
};
export default Toast;
